module.exports = "<section id=\"resultados\" class=\"section\">\r\n    <h2 class=\"display-4 title\"><i class=\"fa fa-pie-chart\"></i> Resultados de encuestas</h2>\r\n    <div class=\"list-survey\">\r\n\r\n        <div *ngFor=\"let survey of surveys | mainFilter:filterargs ;  let i=index\">\r\n            <app-card [survey]=\"survey\" *ngIf=\"i<showNumber\"></app-card>\r\n        </div>\r\n    </div>\r\n</section>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/surveys/surveys.component.html
// module id = ../../../../../src/app/surveys/surveys.component.html
// module chunks = main